<template>
  <grid-layout
    :layout.sync="layout"
    :col-num="12"
    :is-draggable="isDraggable"
    :is-resizable="true"
    :is-mirrored="false"
    :vertical-compact="true"
    :margin="[10, 10]"
    :use-css-transforms="true"
    :responsive="true"
    @layout-created="layoutCreatedEvent"
    @layout-before-mount="layoutBeforeMountEvent"
    @layout-mounted="layoutMountedEvent"
    @layout-ready="layoutReadyEvent"
    @layout-updated="layoutUpdatedEvent"
    @breakpoint-changed="breakpointChangedEvent"
  >
    <grid-item
      class="item-lay"
      v-for="item in layout"
      :x="item.x"
      :y="item.y"
      :w="item.w"
      :h="item.h"
      :i="item.i"
      :key="item.i"
      @resize="resizedEvent"
      @move="movedEvent"
      @resized="resizedEvent"
      @moved="movedEvent"
    >
      <slot></slot>
    </grid-item>
  </grid-layout>
</template>
<script>
import VueGridLayout from 'vue-grid-layout';
export default {
  name: 'gridLayout',
  props: {
    isDraggable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      layout: [
        {
          x: 0,
          y: 0,
          w: 2,
          h: 1,
          i: '0',
          resizable: true,
          draggable: false,
          static: false,
          maxH: 5,
          maxW: 12,
        },
      ],
    };
  },
  components: {
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
  },
  methods: {
    movedEvent: function (i, newX, newY, e) {
      localStorage.setItem('pandectDisplace', JSON.stringify(this.layout));
    },
    resizedEvent: function (i, newH, newW, newHPx, newWPx) {
      // console.log("RESIZED i=" + i + ", H=" + newH + ", W=" + newW + ", H(px)=" + newHPx + ", W(px)=" + newWPx);
      localStorage.setItem('pandectDisplace', JSON.stringify(this.layout));
    },
    layoutCreatedEvent: function (newLayout) {
      console.log('Created layout: ', newLayout);
    },
    layoutBeforeMountEvent: function (newLayout) {
      console.log('beforeMount layout: ', newLayout);
    },
    layoutMountedEvent: function (newLayout) {
      console.log('Mounted layout: ', newLayout);
    },
    layoutReadyEvent: function (newLayout) {
      console.log('Ready layout: ', newLayout);
    },
    layoutUpdatedEvent: function (newLayout) {
      console.log('Updated layout: ', newLayout);
    },
    breakpointChangedEvent: function (newBreakpoint, newLayout) {
      console.log(
        'breakpoint changed breakpoint=',
        newBreakpoint,
        ', layout: ',
        newLayout
      );
    },
  },
};
</script>
<style scoped>
.item-lay {
  border: 1px solid #e5e5e5;
}
</style>
